var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7111 21.7296L23.5385 10H17.846L12.7111 21.7296ZM16.536 10L12 20.3617L7.464 10H16.536ZM17.9451 8.5H23.5L21.2764 4.05279C21.107 3.714 20.7607 3.5 20.382 3.5H16.8859L17.9451 8.5ZM15.6593 3.5L16.7185 8.5H7.28155L8.34074 3.5H15.6593ZM6.05492 8.5L7.11411 3.5H3.61804C3.23927 3.5 2.89301 3.714 2.72362 4.05279L0.500009 8.5H6.05492ZM11.2889 21.7297L6.15405 10H0.461548L11.2889 21.7297Z",
    fill: "#1A1B1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.8ab5bfa07ea7e9aee616664a9ecb7c2d.svg";
export { ForwardRef as ReactComponent };